import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import AuthStore from 'stores/AuthStore';
import InputField from 'components/pure/utils/form/InputField';
import RulesTable from './rules/RulesTable';
import TriggerRuleActions from 'actions/triggers/TriggerRuleActions';
import TriggerRuleStore from 'stores/triggers/TriggerRuleStore';
import pick from 'lodash/pick';
import urlParams from 'utils/urlParams';
import Loading from 'components/pure/utils/Loading';
import {browserHistory} from 'react-router';
import './TriggerRulesStyles.styl';
import Button from '@material-ui/core/Button';
import AccountActions from 'actions/AccountActions';
import AccountStore from 'stores/AccountStore';
import {getQuery} from 'utils/getQueryParam';
import {BellPlusIcon} from '@components/icon/BellPlusIcon';

class TriggersPageContainer extends React.Component {
  static getStores() {
    return [TriggerRuleStore, AuthStore, AccountStore];
  }

  static getPropsFromStores() {
    return {
      ...pick(TriggerRuleStore.getState(), ['rules', 'rulesLoading', 'rulesErrored']),
      sessionUser: AuthStore.getState().user,
      ...pick(AccountStore.getState(), ['hasSalesforceLoaded', 'hasSalesforceLoading']),
    };
  }

  constructor(props) {
    super(props);
    this.onSearch = this.onSearch.bind(this);
  }

  componentDidMount() {
    TriggerRuleActions.fetchTriggerRules().then(rules => {
      if (rules.size === 0) {
        browserHistory.push('/admin/actions/create');
      }
    });

    if (!this.props.hasSalesforceLoaded && !this.props.hasSalesforceLoading) {
      AccountActions.accountHasSalesforce();
    }
  }

  onSearch(searchText) {
    const {location} = this.props;
    browserHistory.replace(
      location.pathname +
        urlParams({
          ...getQuery(location),
          searchText: encodeURIComponent(searchText),
        })
    );
  }

  render() {
    const {rules, rulesLoading, rulesErrored, location} = this.props;
    const {hash} = location;
    const highlighted = hash === null ? null : parseInt(hash.substring(1), 10);
    const {searchText} = getQuery(location);

    if (rulesLoading) {
      return <Loading />;
    }

    return (
      <div className="triggers-page">
        <h1 style={{pointerEvents: 'none'}}>Smart Alerts</h1>
        <div className="tool-bar">
          <Button
            variant="contained"
            color="primary"
            onClick={() => browserHistory.push('/admin/actions/create')}
            className="create-smart-alert-button"
            startIcon={<BellPlusIcon height={15} fill={'#FFF'} />}>
            Create Smart Alert
          </Button>
          <InputField
            type="text"
            onChange={this.onSearch}
            placeholder="Filter"
            value={decodeURIComponent(searchText || '')}
          />
        </div>
        {rulesErrored ? (
          <div className="ev-error-message">There was an error loading the Smart Alerts</div>
        ) : (
          <RulesTable
            rules={rules}
            searchText={searchText}
            highlighted={highlighted}
            {...this.props}
          />
        )}
      </div>
    );
  }
}

export default connectToStores(TriggersPageContainer);
